(function () {
  'use strict';

  /* =========================
     Utilitaires
     ========================= */
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function initCustomUpload() {
    var container = document.querySelector('[data-custom-upload]');
    if (!container) return;

    var endpoint = window.CUSTOM_UPLOAD_ENDPOINT;
    // Normalise l'URL pour éviter le 301 /upload -> /upload/
    if (endpoint && endpoint.endsWith('/upload')) endpoint += '/';

    if (!endpoint) {
      console.error('[UPLOAD] CUSTOM_UPLOAD_ENDPOINT manquant');
      return;
    }

    var debugMode = (window.CUSTOM_UPLOAD_DEBUG === true);

    function dlog() {
      if (!debugMode) return;
      try { console.log.apply(console, ['[UPLOAD]'].concat([].slice.call(arguments))); }
      catch (e) {}
    }

    var fileInput = container.querySelector('#CustomImageFile');
    var statusEl  = container.querySelector('#CustomUploadStatus');
    var debugEl   = container.querySelector('#CustomUploadDebug');
    var uploadIdEl   = container.querySelector('#CustomUploadId');
    var uploadNameEl = container.querySelector('#CustomUploadFilename');

    if (!fileInput || !statusEl || !uploadIdEl || !uploadNameEl) {
      console.error('[UPLOAD] éléments DOM manquants');
      return;
    }

    function setStatus(html, isError) {
      statusEl.innerHTML = html;
      statusEl.style.color = isError ? '#c00' : '#2a7';
    }

    function showDebugHtml(html) {
      if (!debugEl || !debugMode) return;
      debugEl.style.display = 'block';
      debugEl.innerHTML = html;
    }

    function hideDebug() {
      if (!debugEl) return;
      debugEl.style.display = 'none';
      debugEl.innerHTML = '';
    }

    // Si debug désactivé, on s’assure que le bloc debug est caché
    if (debugEl && !debugMode) hideDebug();

    /* =========================
       Upload handler
       ========================= */
    fileInput.addEventListener('change', async function () {
      uploadIdEl.value = '';
      uploadNameEl.value = '';
      hideDebug();

      var file = fileInput.files && fileInput.files[0];
      if (!file) return;

      // Vérifs client
      var allowed = ['image/jpeg', 'image/png', 'image/webp'];
      if (!allowed.includes(file.type)) {
        setStatus('❌ Format non accepté (JPG / PNG / WebP)', true);
        fileInput.value = '';
        return;
      }

      if (file.size > 15 * 1024 * 1024) {
        setStatus('❌ Fichier trop volumineux (max 15 Mo)', true);
        fileInput.value = '';
        return;
      }

      // Statut "utilisateur" (pas de détails techniques)
      setStatus('⏳ Upload en cours…', false);

      try {
        var formData = new FormData();
        formData.append('file', file);

        dlog('envoi vers', endpoint);

        var res = await fetch(endpoint, {
          method: 'POST',
          body: formData
        });

        var raw = await res.text();

        if (!res.ok) {
          throw new Error('HTTP ' + res.status + ' — ' + raw.slice(0, 300));
        }

        var data;
        try {
          data = JSON.parse(raw);
        } catch (e) {
          throw new Error('Réponse non-JSON — ' + raw.slice(0, 300));
        }

        if (!data.upload_id) {
          throw new Error('upload_id manquant — ' + raw.slice(0, 300));
        }

        uploadIdEl.value = data.upload_id;
        uploadNameEl.value = data.original_name || file.name;

        // Statut propre (sans upload_id ni chemin)
        setStatus('✅ Image ajoutée : <strong>' + escapeHtml(uploadNameEl.value) + '</strong>', false);

        // Debug uniquement si debugMode
        showDebugHtml(
          '<strong>DEBUG UPLOAD</strong><br>' +
          'endpoint : <code>' + escapeHtml(endpoint) + '</code><br>' +
          'upload_id : <code>' + escapeHtml(data.upload_id) + '</code><br>' +
          'original_name : <code>' + escapeHtml(data.original_name || file.name) + '</code><br>' +
          (data.stored_path ? 'stored_path : <code>' + escapeHtml(data.stored_path) + '</code><br>' : '') +
          (data.stored_file ? 'stored_file : <code>' + escapeHtml(data.stored_file) + '</code><br>' : '') +
          (data.meta ? 'meta : <code>' + escapeHtml(data.meta) + '</code><br>' : '') +
          (data.bytes ? 'bytes : <code>' + escapeHtml(data.bytes) + '</code><br>' : '') +
          (data.mime ? 'mime : <code>' + escapeHtml(data.mime) + '</code><br>' : '') +
          '<br><em>raw:</em><br><code style="white-space:pre-wrap;display:block;">' + escapeHtml(raw) + '</code>'
        );

        dlog('OK', data);

      } catch (err) {
        console.error('[UPLOAD ERROR]', err);

        // Statut propre (message utilisateur)
        setStatus('❌ Erreur upload. Réessayez.', true);

        // Détails uniquement en debug
        showDebugHtml(
          '<strong>DEBUG ERREUR</strong><br>' +
          '<code style="white-space:pre-wrap;display:block;">' + escapeHtml(String(err)) + '</code>'
        );

        fileInput.value = '';
      }
    });

    /* =========================
       Blocage ajout panier
       ========================= */
    var form = container.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!uploadIdEl.value) {
          e.preventDefault();
          setStatus('❌ Veuillez joindre une image avant d’ajouter au panier.', true);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initCustomUpload);
})();
